import { render, staticRenderFns } from "./IrrResourceMapComponent.vue?vue&type=template&id=975ec566"
import script from "./IrrResourceMapComponent.vue?vue&type=script&lang=js"
export * from "./IrrResourceMapComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports